export default function isEven(num) {
  return num % 2 === 0
}



// WEBPACK FOOTER //
// ./src/utils/is-even.js